import { Box } from '@mui/system';
import oxTheOx from '../../assets/images/ox-the-ox.svg';

const ComingSoon: React.FC<React.PropsWithChildren<unknown>> = () => {
  return (
    <Box
      height='100%'
      display='flex'
      alignItems='center'
      justifyContent='center'
      gap={5}>
      <Box component='img' src={oxTheOx} alt='coming soon' maxHeight='80vh' />
    </Box>
  );
};

export default ComingSoon;
